import React, { useCallback } from 'react';
import { MenuItem, SalvButton, SalvDataTag, SalvMenuButton, Size } from '@salvapp/ui-components';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { RateLimitBucket } from './RateLimiterConfig';
import { showConfirmationModal } from '../../confirmation-modal/confirmationModalReducer';
import { useDispatch } from 'react-redux';

interface Props {
  text: string;
  limit: string;
  showEditButton?: boolean;
  availableBuckets: RateLimitBucket[];
  onEdit: () => void;
  onGroupSelect: (groupName: string) => void;
}

export const ADD_NEW_GROUP = 'ADD_NEW_GROUP';

const RateLimiterTableHeader = ({ text, limit, showEditButton, availableBuckets, onEdit, onGroupSelect }: Props) => {
  const dispatch = useDispatch();

  const handleGroupSelect = useCallback(
    (groups: string[]) => {
      const groupId = groups[0];
      if (groupId === ADD_NEW_GROUP) {
        onGroupSelect(groupId);
      } else {
        const groupName = availableBuckets.find((it) => it.id === groupId)?.bucketName;
        dispatch(
          showConfirmationModal({
            title: `Are you sure you that you want to move these end points to "${groupName}"?`,
            onConfirm() {
              onGroupSelect(groupId);
            },
            confirmationText: 'Yes, move',
            icon: faTriangleExclamation,
          })
        );
      }
    },
    [availableBuckets]
  );

  return (
    <div className='rate-limit-table-header'>
      <div className='rate-limiter-info'>
        <div className='title title-s'>{text}</div>
        <SalvDataTag label={'Rate limit'} value={limit} />
      </div>
      <div className='buttons'>
        {showEditButton ? (
          <SalvButton label='Edit group' onClick={onEdit} variant='muted' size={Size.SMALL} />
        ) : (
          <SalvMenuButton
            className='move-to-group-button'
            size={Size.SMALL}
            onAction={handleGroupSelect}
            label='Move to group'
            enableFilter
            placement='bottom end'
          >
            <MenuItem
              title='Add to a new group'
              value={ADD_NEW_GROUP}
              icon={faPlus}
              sectionEnd={!!availableBuckets.length}
            />
            {availableBuckets.map((bucket) => (
              <MenuItem key={bucket.id} title={bucket.bucketName} value={bucket.id} />
            ))}
          </SalvMenuButton>
        )}
      </div>
    </div>
  );
};

export default RateLimiterTableHeader;
